import graphqlClient from "../../../apollo";

class RecargoProvider {

    findRecargo(id) {
        return graphqlClient.query({
            query: require('./gql/recargoFind.graphql'),
            variables: { id: id }
        })
    }

    fetchRecargos() {
        return graphqlClient.query({
            query: require('./gql/recargoFetch.graphql'),
            fetchPolicy: "network-only"
        })
    }

    paginateRecargos(pageNumber, itemsPerPage, search = null, orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/recargoPaginate.graphql'),
            variables: { pageNumber, itemsPerPage, search, orderBy, orderDesc },
            fetchPolicy: "network-only"
        })
    }



    createRecargo(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/recargoCreate.graphql'),
            variables: form
        })
    }

    updateRecargo(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/recargoUpdate.graphql'),
            variables: form
        })
    }

    deleteRecargo(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/recargoDelete.graphql'),
            variables: { id }
        })
    }

}

export default new RecargoProvider()
